const copy = {
  workspace: ['Your workspace', 'Tu espacio de trabajo'],
  search: ['Find a tool or start work', 'Busca una herramienta o empieza a trabajar'],
  switch: ['Switch workspace', 'Cambiar de espacio'],
  title: ['Where would you like to go?', '¿A dónde quieres ir?'],
  placeholder: ['Try “invoice”, “campaign” or “tasks”…', 'Prueba “factura”, “campaña” o “tareas”…'],
  close: ['Close search', 'Cerrar búsqueda'],
  suggested: ['Suggested for this workspace', 'Sugerencias para este espacio'],
  recent: ['Recently opened', 'Abierto recientemente'],
  actions: ['Get work done', 'Avanza con tu trabajo'],
  workspaces: ['Workspaces', 'Espacios de trabajo'],
  none: ['No matching tools in your available workspaces.', 'No hay herramientas que coincidan en tus espacios disponibles.'],
  help: ['Try a shorter task, such as invoices, contacts or tasks.', 'Prueba una tarea más breve, como facturas, contactos o tareas.'],
  navigate: ['Navigate', 'Navegar'],
  open: ['Open', 'Abrir'],
  dismiss: ['Close', 'Cerrar'],
  settings: ['Account settings', 'Configuración de la cuenta'],
  results: ['available results', 'resultados disponibles'],
  privacy: ['Tools and shortcuts only. Business records stay in their workspaces.', 'Solo herramientas y accesos directos. Los registros permanecen en sus espacios.'],
};

export const spanishWorkspace = language => /^es(?:-|$)/i.test(language || '');
export const workspaceCopy = (language, key) => copy[key]?.[spanishWorkspace(language) ? 1 : 0] || key;
export const commandLabel = (command, language) => command[spanishWorkspace(language) ? 'es' : 'en'];
